// Stub for Node built-ins referenced by browser bundles.
module.exports = {};
